import { TranslationObject } from '../i18n/translation';

const namespace = 'registration';

const translations: TranslationObject = {
  header: {
    id: `${namespace}.header`,
    nb: 'Vennligst bekreft din e-postadresse for å fullføre registrering',
    en: 'Please confirm your email address to complete registration',
  },
  button: {
    id: `${namespace}.button`,
    nb: 'Bekreft',
    en: 'Confirm',
  },
  helptext: {
    id: `${namespace}.helpText`,
    nb: 'E-postadressen skal være den samme som du mottok invitasjon på',
    en: 'Make sure to enter the same email address as the one you received the invitation on',
  },
  title: {
    id: `${namespace}.title`,
    nb: 'Registrering - Arbeidslivsportalen',
    en: 'Registration - Arbeidslivsportalen',
  },
  email: {
    id: `${namespace}.email`,
    nb: 'E-post',
    en: 'Email',
  },
};

export default translations;
